import { AuthApi } from 'api/auth';
import Axios from 'axios';
import { getFromLocalStorage } from 'global/utils/storage';
import { AUTH_TOKEN } from 'config/constant';
import { DocumentApi } from 'api/document';
import { VehiclesApi } from 'api/vehicles';
import { RequestConfiguration } from './api.types';

export const axios = Axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
});

axios.interceptors.request.use(
  async (config: RequestConfiguration) => {
    const token = getFromLocalStorage(AUTH_TOKEN);
    const prefix = config.target ? `${config.target}_` : '';

    if (token) {
      config.url = `${config.url}?${prefix}ticket=${token}`;
    }

    return config;
  },
  error => Promise.reject(error),
);

class Api {
  public auth: AuthApi;

  public document: DocumentApi;

  public vehicles: VehiclesApi;

  constructor() {
    this.auth = new AuthApi(axios);
    this.document = new DocumentApi(axios);
    this.vehicles = new VehiclesApi(axios);
  }
}

export const api = new Api();
